<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditOrgForm" :rules="addEditOrgRules" ref="addEditOrgForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="类型" prop="name">
      <div style="text-align: left">
        <el-radio-group v-model="addEditOrgForm.org_type">
          <el-radio :label="1">楼栋</el-radio>
          <el-radio :label="2">楼层</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item label="名称" prop="name">
      <el-input v-model="addEditOrgForm.name" placeholder="请输入名称"></el-input>
    </el-form-item>
    <el-form-item v-if="addEditOrgForm.org_type === 1" label="上级组织" prop="orgpid1">
      <el-cascader v-fixZoom style="width: 100%" :options="orgOptions1" v-model="addEditOrgForm.orgpid1" :filterable="true" placeholder="请选择上级组织"
                   :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
        ref="orgOptions1" @change="getOrgLevel1">
      </el-cascader>
    </el-form-item>
    <el-form-item v-if="addEditOrgForm.org_type === 2" label="上级楼栋" prop="orgpid2">
      <el-cascader v-fixZoom style="width: 100%" :options="orgOptions2" v-model="addEditOrgForm.orgpid2" :filterable="true" placeholder="请选择上级组织"
                   :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                   ref="orgOptions2" @change="getOrgLevel2">
      </el-cascader>
    </el-form-item>
  </el-form>
  <div style="margin-top: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAdd()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddOrg('addEditOrgForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {addorg, updateorg} from '../../../api/organizer'

export default {
  name: 'addEditBuild',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    orgRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // radio: '1',
      orgOptions1: [],
      orgOptions2: [],
      orgArr1: [],
      orgArr2: [],
      addEditOrgForm: {
        id: 0,
        name: '',
        level: '',
        orgpid1: '',
        orgpid2: '',
        org_type: 1
      },
      addEditOrgRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        orgpid1: [
          { required: true, message: '请选择所属上级组织', trigger: 'change' }
        ],
        orgpid2: [
          { required: true, message: '请选择所属楼层', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    console.log(123, this.orgRow)
    this.orgOptions1 = this.clone(this.orgRow.orgArrEnd)
    this.orgArr1 = this.clone(this.orgRow.orgArr1)
    this.orgArr2 = this.clone(this.orgRow.orgArr2)
    if (!this.orgRow.isAdd) {
      this.addEditOrgForm = {
        id: this.orgRow.row.id,
        name: this.orgRow.row.name,
        level: this.orgRow.row.level,
        orgpid1: this.orgRow.row.orgpid,
        orgpid2: this.orgRow.row.orgpid,
        org_type: this.orgRow.row.org_type
      }
    }
  },
  mounted () {
    this.getOrTree2()
  },
  methods: {
    getOrTree2 () {
      // 所属组织
      let lastLevel = 100
      const arr = this.orgRow.orgArr2
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode2(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      // console.log(888, arr, treeData)
      this.orgOptions2 = treeData
    },
    // 递归
    arrayToNode2 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode2(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getOrgLevel1 (id) {
      let level = ''
      this.orgArr1.forEach(item => {
        if (item.id === id) {
          level = item.level + 1
        }
      })
      console.log(level)
      this.addEditOrgForm.level = level
      // console.log(this.addEditOrgForm.orgpid)
    },
    getOrgLevel2 (id) {
      let level = ''
      this.orgArr2.forEach(item => {
        if (item.id === id) {
          level = item.level + 1
        }
      })
      console.log(level)
      this.addEditOrgForm.level = level
    },
    submitAddOrg (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.addEditOrgForm.id,
            name: this.addEditOrgForm.name,
            level: this.addEditOrgForm.level,
            orgpid: '',
            org_type: this.addEditOrgForm.org_type
          }
          if (data.org_type === 1) {
            data.orgpid = this.addEditOrgForm.orgpid1
          } else if (data.org_type === 2) {
            data.orgpid = this.addEditOrgForm.orgpid2
          }
          if (this.orgRow.isAdd) {
            addorg(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加',
                type: 'success',
                duration: 2000
              })
              this.$emit('changeAddEdit')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '添加失败'
              })
            })
          } else {
            updateorg(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑',
                type: 'success',
                duration: 2000
              })
              this.$emit('changeAddEdit')
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '编辑失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditBuild.vue